import api from '@/apis/dashboard/dashboardReceivableDebtAPI';
import Chart from '@/stores/baseChart';
const chart = new Chart('receivableDebt', api);

const state = {
  ...chart.state,
};
const getters = {
  ...chart.getters,
};
const actions = {
  ...chart.actions,
};
const mutations = {
  ...chart.mutations,
};

export default {
  // eslint-disable-next-line no-undef
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};